import React from 'react';

const SettingsNetwork = (props: { active: boolean }) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13.4 10.4H11a.6.6 0 00-.6.6v2.4a.6.6 0 00.6.6h2.4a.6.6 0 00.6-.6V11a.6.6 0 00-.6-.6zM5 10.4H2.6a.6.6 0 00-.6.6v2.4a.6.6 0 00.6.6H5a.6.6 0 00.6-.6V11a.6.6 0 00-.6-.6zM9.2 2H6.8a.6.6 0 00-.6.6V5a.6.6 0 00.6.6h2.4a.6.6 0 00.6-.6V2.6a.6.6 0 00-.6-.6zM3.8 10.4V8.6a.6.6 0 01.6-.6h7.2a.6.6 0 01.6.6v1.8M8 8V5.6"
				stroke={props.active ? 'url(#icon-gradient)' : '#6683A7'}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default SettingsNetwork;
